import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import {labels} from '../../../../../../util/utils';
import Ellipses from '../../../../EllipsesControl/EllipsesPresets';

export const BodySpecialAccordionContentListItemRemove = ({showRemove, removeLabel, onClick, styleName, id}) => {
	return (
		<StyledBodySpecialAccordionContentListItemRemove id={id} className={styleName} onClick={(e) => onClick(e)}>
			{showRemove && <Ellipses.Single>{removeLabel}</Ellipses.Single>}
		</StyledBodySpecialAccordionContentListItemRemove>
	);
};

BodySpecialAccordionContentListItemRemove.propTypes = {
	onClick: PropTypes.func.isRequired,
	removeLabel: PropTypes.string,
	showRemove: PropTypes.bool
};

BodySpecialAccordionContentListItemRemove.defaultProps = {
	showRemove: false,
	removeLabel: labels.remove
};

export default BodySpecialAccordionContentListItemRemove;

const StyledBodySpecialAccordionContentListItemRemove = styled.a`
	max-width: var(--px-80);
	cursor: pointer;
	&:hover {
		text-decoration: underline;
	}
	.ellipses {
		justify-content: flex-end;
	}
`;
